import React from 'react'

const Checkbox = ({ label, value, setValue, errors, name }) => {
    return (
        <div className={`checkbox ${errors && errors.includes(name) ? 'error' : ''}`}>
            <input type="checkbox" checked={value} onChange={() => setValue(!value)} />
            <label  onClick={() => setValue(!value)}> {label}</label>
        </div>
    )
}

export default Checkbox